import { v4 as uuidv4 } from 'uuid';

export class PlanDto {
  guid?: string;
  name?: string;
  identificationCode?: string;
  edition?: string;
  date?: Date;
  notes?: string;
  fileId?: string;
  fileName?: string;
  creator?: string;
  isPassed?: boolean | null;
}

export class Plan extends PlanDto {
  constructor(data: PlanDto = {}) {
    super();
    this.guid = data.guid || uuidv4();
    this.name = data.name;
    this.identificationCode = data.identificationCode;
    this.edition = data.edition;
    this.date = data.date;
    this.notes = data.notes;
    this.fileId = data.fileId;
    this.fileName = data.fileName;
    this.creator = data.creator;
    this.isPassed = data.isPassed;
  }
}
